import { PaymentMethodTypes, Paypal } from '@accedo/one-plugin-sdk';
import { t } from 'i18next';
import { useState } from 'react';

import { FormButton } from '#/components/Form/Form.styled';
import { FormButtonDisclaimer } from '#/components/Form/FormButton';
import tempPromoStore from '#/components/PlanPicker/tempPromoStore';
import { ignoreError } from '#/service/utils';

import { usePaymentContext } from '../context';
import * as Styled from '../styled';

const PaymentPayPalForm = () => {
  const [loading, setLoading] = useState(false);
  const {
    callPaymentAnalytics,
    onPaymentChange,
    actions: { purchase },
    selectedPlan,
    customParameters = {},
    voucher,
  } = usePaymentContext();

  const handleClickButton = () => {
    const planId = selectedPlan?.id ?? '';
    setLoading(true);

    const promoDetails = tempPromoStore.read();
    const params = {
      ...customParameters,
      ...(promoDetails.customSubscriptionParameters ?? {}),
    };

    purchase(planId, {
      paymentMethod: {
        type: PaymentMethodTypes.Paypal,
      },
      voucherCode: voucher,
      customParameters: params,
      startDate: promoDetails.startDate,
      customOrderParameters: promoDetails.customOrderParameters,
    })
      .then((result) => {
        const paypalResult = result?.paymentMethod?.properties as Paypal;

        callPaymentAnalytics().catch(ignoreError);
        onPaymentChange({ isSuccessful: true, isExternal: true });

        if (paypalResult?.redirectUrl) {
          window.open(paypalResult.redirectUrl, '_self');
        }
      })
      .catch(() => {
        throw new Error('Paypal payment failed to call.');
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Styled.Text>
        {t('web.iap.paymentMethods.paypal.description')}
      </Styled.Text>
      <Styled.DisclaimerWrapper>
        <FormButtonDisclaimer
          disclaimer={t('web.iap.paymentMethods.paypal.disclaimer')}
        >
          <FormButton isLoading={loading} onClick={handleClickButton}>
            {t('web.iap.paymentMethods.paypal.button')}
          </FormButton>
        </FormButtonDisclaimer>
      </Styled.DisclaimerWrapper>
    </>
  );
};

export default PaymentPayPalForm;
